





























import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { SmsConfigModel } from "@/api/models/accesPlateformeBeneficiaires/accesPlateformeBeneficiaire";
import SearchableVueSelect from "@/components/selects/SearchableVueSelect.vue";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import {
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BFormTags,
  BRow,
  BSpinner,
} from "bootstrap-vue";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({
  components: {
    BButton,
    BCol,
    BFormTags,
    BRow,
    BCard,
    BFormCheckbox,
    BSpinner,
    SearchableVueSelect,
    FeatherIcon,
  },
  name: "sms-config",
})
export default class SmsConfig extends Vue {
  @Prop({ type: Boolean, required: true }) smsActive!: boolean;
  @Prop({ type: String, required: true })
  accesPlateformeBeneficiaireId!: string;

  localSmsActive: boolean = this.smsActive;

  tagsList: string[] = [];

  syncing: boolean = false;

  async created() {}

  @Watch("smsActive")
  onSmsActiveChanged(val: boolean) {
    this.localSmsActive = val;
  }

  onToggleSms() {
    this.$emit("update:sms-active", this.localSmsActive);
  }

  async saveSmsConfiguration() {
    try {
      var smsConfig: SmsConfigModel = {
        smsActive: this.localSmsActive,
      };

      await this.$http.myressif.accesPlateformeBeneficiaire.updateSmsConfig(
        this.accesPlateformeBeneficiaireId,
        smsConfig
      );

      successAlert.fire({
        title: "Configuration des SMS",
        text: "Configuration enregistrée avec succès.",
      });

      this.$emit("reload");

      return true;
    } catch (error: any) {
      errorAlert.fire({
        title: "Erreur d'enregistrement",
        text: error?.response?.data?.detail || error.message,
      });
      return false;
    }
  }
  async syncSmsConfiguration() {
    try {
      await this.saveSmsConfiguration();

      await this.$http.myressif.accesPlateformeBeneficiaire.syncSmsConfig(
        this.accesPlateformeBeneficiaireId
      );

      successAlert.fire({
        title: "Synchronisation de la configuration des SMS",
        text: "Synchronisation effectuée avec succès.",
      });
    } catch (error: any) {
      errorAlert.fire({
        title: "Erreur de synchronisation",
        text: error?.response?.data?.detail || error.message,
      });
    } finally {
      this.$emit("reload");
    }
  }
}
